module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event3/younite-event-ko-885b3699fc39c29e9ace60691fbbec0e.png";